'use client'
import { useSearchParams } from 'next/navigation'
import { type ShopSessionAttributionInput } from '@/services/graphql/generated'

export function useShopSessionAttribution(): ShopSessionAttributionInput | null {
  const searchParams = useSearchParams()

  if (!searchParams) return null

  const attributedTo = getAttributedTo(searchParams)
  if (!attributedTo && !isGoogleClick(searchParams)) return null

  return {
    attributedTo,
    trackingData: getTrackingData(searchParams),
  }
}

function getAttributedTo(searchParams: URLSearchParams) {
  return searchParams.get('utm_source') === 'addrevenue.io' ? 'addrevenue.io' : null
}

function isGoogleClick(searchParams: URLSearchParams) {
  return !!(searchParams.get('gclid') || searchParams.get('gbraid') || searchParams.get('wbraid'))
}

function getTrackingData(searchParams: URLSearchParams) {
  return {
    advertiserId: searchParams.get('advertiserId'),
    channelId: searchParams.get('channelId'),
    clickId: searchParams.get('clickId'),
    clickRef: searchParams.get('clickRef'),
    market: searchParams.get('market'),
    gclid: searchParams.get('gclid'),
    gbraid: searchParams.get('gbraid'),
    wbraid: searchParams.get('wbraid'),
    trafficSource: isGoogleClick(searchParams) ? 'google' : null,
    utmSource: searchParams.get('utm_source'),
    utmMedium: searchParams.get('utm_medium'),
    utmCampaign: searchParams.get('utm_campaign'),
  }
}
